export default {
  GIVE_FEEDBACK: `Envoyer un commentaire`,
  GIVE_FEEDBACK_MERINIO: `À l'équipe Merinio`,
  GIVE_FEEDBACK_EMPLOYER: `À mon employeur`,
  FEEDBACK_TEXTAREA: {
    PLACEHOLDER: `Écrivez vos commentaires ici`,
    DESCRIPTION: ``,
    LABEL: ``
  },
  FEEDBACK_MODAL_NONE: {
    TITLE: `Envoyer un commentaire`,
    SUMMARY: `À qui voulez-vous envoyer un commentaire?`
  },
  FEEDBACK_MODAL_MERINIO: {
    TITLE: `Envoyer un commentaire à l'équipe Merinio`,
    SUMMARY: `Utilisez ce formulaire afin de nous partager vos expériences avec Merinio, n'hésitez pas à partager des frustrations ou une idée de fonctionnalité. Nous ne pouvons pas régler vos problèmes sans les connaître!`
  },
  FEEDBACK_MODAL_EMPLOYER: {
    NOT_SUPPORTED: `Cette fonctionalité n'est pas configurée, veuillez contacter votre gestionnaire pour savoir où envoyer vos commentaires.`,
    TITLE: `Envoyer un commentaire à votre employeur`,
    SUMMARY: `Tout commentaire envoyé par l'entremise de ce formulaire sera acheminé vers un courriel défini par votre employeur.`
  }
}
